import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-417da316"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "text-overflow-2 title" }
const _hoisted_4 = { class: "sub-text-wrapper" }
const _hoisted_5 = { class: "primary" }
const _hoisted_6 = { key: 0 }

import { onMounted } from 'vue';

  interface IProps {
    variantId: number;
    imageUrl: string;
    title: string;
    primaryText?: string | number;
    subText?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    variantId: null,
    imageUrl: null,
    title: null,
    primaryText: null,
    subText: null
  },
  setup(__props: any) {

const props = __props as {
    variantId: number;
    imageUrl: string;
    title: string;
    primaryText?: string | number;
    subText?: string;
  }

  

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'variant.detail', params: { id: props.variantId } },
    class: "item-wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: props.imageUrl,
        class: "image"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(props.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("strong", _hoisted_5, _toDisplayString(props.primaryText), 1),
          (props.subText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.subText), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})